import { useEffect } from 'react';
import { CircularProgressbar as ReactCircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const RegisteredCircularProgressbar = (props) => {


    const customStyles = {
        path: {
            stroke: '#6ebe44',
            strokeLinecap: 'round',
        },
        text: {
            fontFamily: 'Inter',
            fill: '#000000',
            fontSize: '30px',
            fontWeight: '500',
            lineHeight: '13.31px',
            color: "#000000",
            opacity: '87%',
        },
        trail: {
            stroke: '#d6d6d6',
        },
    };

    return (
        <div style={{ width: 42, height: 42 }}>
            <ReactCircularProgressbar
                value={props?.value ? props?.value : 0}
                text={props?.text ? props?.text: "0/1"}
                styles={customStyles}
            />
        </div>
    );
}

export default RegisteredCircularProgressbar;
